export class PaymentInvoiceData {

  private static stringKeys = [
    'userFirstName', 'userLastName', 'programName', 'feeName', 'clubName', 'clubLogo', 'receiptNumber', 'paymentMethod'
  ];

  private static numKeys = ['invoiceNumber', 'paidAmount'];

  invoiceNumber: number;
  userFirstName: string;
  userLastName: string;
  programName: string;
  feeName: string;
  clubName: string;
  clubLogo: string;
  paidAmount: number;
  receiptNumber: string;
  paidDate: Date;
  paymentMethod: string;

  constructor(data) {
    PaymentInvoiceData.stringKeys.forEach(key => this[key] = data[key]);
    PaymentInvoiceData.numKeys.forEach(key => this[key] = data[key]);
    this.paidDate = new Date(data.paidDate);

  }

}



// WEBPACK FOOTER //
// ./src/app/models/payment-invoice-data.ts